import { Button, Flex, Grid } from '@radix-ui/themes';
import { createFileRoute, Link, Outlet, useLocation, useNavigate } from '@tanstack/react-router';
import { Suspense, useState } from 'react';
import { useLocalStorage } from 'usehooks-ts';
import { TbHeadset, TbHome, TbBolt, TbSettingsAutomation, TbAlertTriangle } from 'react-icons/tb';
import { Header } from '~/components/Header';
import { Loading } from '~/components/Loading';
import { SlidingTooltip } from '~/features/home/components/SlidingTooltip';
import { AccountDropdown } from '~/features/project/components/AccountDropdown';
import Styles from '~/styles/routes.module.scss';
import { useBreakpoint } from '~/utils/breakpoints';

export const Route = createFileRoute('/_auth/_home/_layout')({
  component: RouteComponent,
});

function RouteComponent() {
  const navigate = useNavigate();
  const location = useLocation();
  const [isPopoverOpen, setIsPopoverOpen] = useState(false);
  const breakpoint = useBreakpoint();
  const [enableAutomations] = useLocalStorage(
    'enableAutomations',
    localStorage.getItem('enableAutomations') === 'true' || false
  );

  return (
    <Flex direction="column" minHeight="0" pb="5" flexGrow="1">
      <Header disableLink className={Styles.LayoutHeader}>
        <Flex gap="4">
          <Button
            variant="outline"
            color="gray"
            size="2"
            onClick={() => window.open('https://calendly.com/versori', '_blank')}
          >
            <TbHeadset />
            {breakpoint !== 'initial' && breakpoint !== 'xs' ? 'Book a Demo' : 'Demo'}
          </Button>
          <AccountDropdown
            isPopoverOpen={isPopoverOpen}
            setIsPopoverOpen={setIsPopoverOpen}
            handleNavigationToAccount={() => navigate({ to: '/account' })}
          />
        </Flex>
      </Header>
      <Grid className={Styles.HomeLayout}>
        <nav className={Styles.HomeLayoutNavBar}>
          <SlidingTooltip content="Home">
            <Link to="/home" className={Styles.HomeLayoutNavBarItem} data-active={location.pathname === '/home'}>
              <TbHome fontSize="2rem" color={location.pathname === '/home' ? 'var(--cyan-12)' : 'var(--gray-11)'} />
            </Link>
          </SlidingTooltip>
          <SlidingTooltip content="Integrations">
            <Link
              to="/home/integrations"
              className={Styles.HomeLayoutNavBarItem}
              data-active={location.pathname === '/home/integrations'}
            >
              <TbBolt
                fontSize="2rem"
                color={location.pathname === '/home/integrations' ? 'var(--cyan-12)' : 'var(--gray-11)'}
              />
            </Link>
          </SlidingTooltip>
          {enableAutomations && (
            <SlidingTooltip content="Automations">
              <Link
                to="/home/automations"
                className={Styles.HomeLayoutNavBarItem}
                data-active={location.pathname === '/home/automations'}
              >
                <TbSettingsAutomation
                  fontSize="2rem"
                  color={location.pathname === '/home/automations' ? 'var(--cyan-12)' : 'var(--gray-11)'}
                />
              </Link>
            </SlidingTooltip>
          )}
          <SlidingTooltip content="Issues">
            <Link
              to="/home/issues"
              className={Styles.HomeLayoutNavBarItem}
              data-active={location.pathname === '/home/issues'}
            >
              <TbAlertTriangle
                fontSize="2rem"
                color={location.pathname === '/home/issues' ? 'var(--cyan-12)' : 'var(--gray-11)'}
              />
            </Link>
          </SlidingTooltip>
        </nav>
        <Flex className={Styles.HomeLayoutContent}>
          <div className={Styles.HomeLayoutContentItem}>
            <Suspense fallback={<Loading />}>
              <Outlet />
            </Suspense>
          </div>
        </Flex>
      </Grid>
    </Flex>
  );
}
